import axios, { AxiosRequestConfig } from 'axios';

const params: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_API_URL || null,
  xsrfCookieName: `${process.env.VUE_APP_COOKIE_PREFIX}csrftoken`,
  xsrfHeaderName: 'X-CSRFToken'
};

const axiosInstance = axios.create(params);

export default axiosInstance;